export class EmailConfigurationModel {
  objectId
  emailAuthUser
  emailAuthPass
  emailAuthService
  emailAuthHost

  constructor(
    objectId = undefined,
    emailAuthUser = undefined,
    emailAuthPass = undefined,
    emailAuthService = undefined,
    emailAuthHost = undefined
  ) {
    this.objectId = objectId
    this.emailAuthUser = emailAuthUser
    this.emailAuthPass = emailAuthPass
    this.emailAuthService = emailAuthService
    this.emailAuthHost = emailAuthHost
  }

  static convertFromParseObject(parseObject) {
    return new EmailConfigurationModel(
      parseObject?.id,
      parseObject?.get("emailAuthUser"),
      parseObject?.get("emailAuthPass"),
      parseObject?.get("emailAuthService"),
      parseObject?.get("emailAuthHost")
    )
  }
}
